/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Not_Manual_ModeInputs */

const vi_error_irrigation_not_manual_mode = /** @type {(inputs: Error_Irrigation_Not_Manual_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống tưới SmartLab không ở chế độ Thủ công nên lệnh chưa được gửi. Chuyển sang Thủ công trên màn điều khiển SmartLab rồi thử lại.`)
};

/**

* @param {Error_Irrigation_Not_Manual_ModeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_not_manual_mode = /** @type {((inputs?: Error_Irrigation_Not_Manual_ModeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Not_Manual_ModeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_not_manual_mode(inputs)
});